import { makeStyles, tokens } from '@fluentui/react-components';

export interface DonutChartSlice {
  label: string;
  color: string;
  /** 0-100 */
  pct: number;
}

interface Props {
  data: DonutChartSlice[];
  /** Texto grande al centro, ej. "92.6%" */
  centerValue: string;
  centerLabel?: string;
  size?: number;
}

const useStyles = makeStyles({
  wrap: { display: 'flex', gap: '24px', alignItems: 'center' },
  ring: { borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' },
  hole: { borderRadius: '50%', background: tokens.colorNeutralBackground1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
  centerValue: { fontSize: '18px', fontWeight: 700 },
  centerLabel: { fontSize: '10.5px', color: tokens.colorNeutralForeground3 },
  legend: { display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 },
  legendRow: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12.5px' },
  dot: { width: '9px', height: '9px', borderRadius: '50%', flex: 'none' },
  pct: { fontWeight: 700 },
});

function toConicGradient(data: DonutChartSlice[]) {
  let acc = 0;
  const stops = data.map(d => {
    const from = acc;
    acc += d.pct;
    return `${d.color} ${from}% ${acc}%`;
  });
  return `conic-gradient(${stops.join(', ')})`;
}

/** Dona con leyenda de porcentajes — ej. calidad y pérdidas por grado. */
export function DonutChart({ data, centerValue, centerLabel, size = 150 }: Props) {
  const s = useStyles();
  const holeSize = Math.round(size * 0.64);

  return (
    <div className={s.wrap}>
      <div className={s.ring} style={{ width: size, height: size, background: toConicGradient(data) }}>
        <div className={s.hole} style={{ width: holeSize, height: holeSize }}>
          <div className={s.centerValue} style={centerValue.length > 12 ? { fontSize: '12px' } : centerValue.length > 9 ? { fontSize: '14px' } : undefined}>{centerValue}</div>
          {centerLabel && <div className={s.centerLabel}>{centerLabel}</div>}
        </div>
      </div>
      <div className={s.legend}>
        {data.map(d => (
          <div key={d.label} className={s.legendRow}>
            <span className={s.dot} style={{ background: d.color }} />
            <span style={{ flex: 1 }}>{d.label}</span>
            <span className={s.pct}>{d.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
